interface IlinkFileToDownload {
  fileBlobUrl: string;
  filename?: string;
  mimetype?: string;
  openInNewWindow?: boolean;
}

/**
 * Funzione che genera il link al file da scaricare.
 */
export function linkFileToDownload(props: IlinkFileToDownload) {
  const { fileBlobUrl, filename, mimetype, openInNewWindow } = props;

  const link = document.createElement('a');
  link.href = fileBlobUrl;
  if (!openInNewWindow || mimetype !== 'application/pdf') {
    link.setAttribute('download', filename ?? '');
  }
  link.setAttribute('target', '_blank');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
